import * as types from './types'
import * as responses from '@cbgms/api/modules/order/index'
import * as requests from '@cbgms/api/modules/order/requests'
import * as workorderRequests from '@cbgms/api/modules/workorder/requests'
import * as workorderResponses from '@cbgms/api/modules/workorder/index'
import * as settingsRequests from '@cbgms/api/modules/settings/requests'
import * as productRequests from '@cbgms/api/modules/products/requests'
import * as productResponses from '@cbgms/api/modules/products'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import {
  CreateWorkorderLineRequest,
  IDiscounts,
  IWorkorder,
  PUTDiscountResponse,
  UpdateWorkorderLineRequest
} from '@cbgms/api/modules/workorder'
import { IProduct } from '@cbgms/api/modules/products'
import { IPaginatedRequestKeyloopWorkOrders, IPostKeyloopTransferBasket, IUpdateWorkOrderReference, WorkorderLineStatus } from '@cbgms/api'

export const getOrderWithRelated = (orderUUID: string) =>
  AsyncAction<responses.GETOrderWithRelatedResponse>({
    type: [types.GET_ORDER_WITH_RELATED, types.GET_ORDER_WITH_RELATED_SUCCESS, types.GET_ORDER_WITH_RELATED_FAILED],
    payload: {
      api: 'gms',
      request: requests.getOrderWithRelated(orderUUID)
    }
  })

export const getOrderLines = (orderUUID: string) =>
  AsyncAction<responses.GETOrderLinesResponse>({
    type: [types.GET_ORDER_LINES, types.GET_ORDER_LINES_SUCCESS, types.GET_ORDER_LINES_FAILED],
    payload: {
      api: 'gms',
      request: requests.getOrderLines(orderUUID)
    }
  })

export const getChangedOrderLines = (orderUUID: string) =>
  AsyncAction<responses.GETOrderLinesResponse>({
    type: [types.GET_CHANGED_ORDER_LINES, types.GET_CHANGED_ORDER_LINES_SUCCESS, types.GET_CHANGED_ORDER_LINES_FAILED],
    payload: {
      api: 'gms',
      request: requests.getChangedOrderLines(orderUUID)
    }
  })

export const putOrder = (orderUUID: string, changes: Partial<IWorkorder>) =>
  AsyncAction<responses.PUTOrderResponse>({
    type: [types.PUT_ORDER, types.PUT_ORDER_SUCCESS, types.PUT_ORDER_FAILED],
    payload: {
      api: 'gms',
      request: requests.putOrder(orderUUID, changes)
    }
  })

export const putOrderLine = (orderUUID: string, lineUUID: string, changes: UpdateWorkorderLineRequest) =>
  AsyncAction<responses.PUTOrderLineResponse>({
    type: [types.PUT_ORDER_LINE, types.PUT_ORDER_LINE_SUCCESS, types.PUT_ORDER_LINE_FAILED],
    payload: {
      api: 'gms',
      request: requests.putOrderLine(orderUUID, lineUUID, changes)
    }
  })

export const postOrderLine = (orderUUID: string, data: CreateWorkorderLineRequest) =>
  AsyncAction<responses.POSTOrderLineResponse>({
    type: [types.POST_ORDER_LINE, types.POST_ORDER_LINE_SUCCESS, types.POST_ORDER_LINE_FAILED],
    payload: {
      api: 'gms',
      request: requests.postOrderLine(orderUUID, data)
    }
  })

export const deleteOrderLine = (orderUUID: string, lineUUID: string) =>
  AsyncAction<responses.GETOrderLinesResponse>({
    type: [types.DELETE_ORDER_LINE, types.DELETE_ORDER_LINE_SUCCESS, types.DELETE_ORDER_LINE_FAILED],
    payload: {
      api: 'gms',
      request: requests.deleteOrderLine(orderUUID, lineUUID)
    }
  })

export const deleteAllOrderLines = (orderUUID: string) =>
  AsyncAction({
    type: [types.DELETE_ALL_ORDER_LINES, types.DELETE_ALL_ORDER_LINES_SUCCESS, types.DELETE_ALL_ORDER_LINES_FAILED],
    payload: {
      api: 'gms',
      request: requests.deleteAllOrderLines(orderUUID)
    }
  })

export const resetOrder = () => ({
  type: types.RESET_ORDER
})

export const getProductsByWorkorder = (orderAccountUUID: string, workorderUUID: string) =>
  AsyncAction<productResponses.GETProductsByOrderResponse>({
    type: [types.GET_PRODUCTS_BY_ORDER, types.GET_PRODUCTS_BY_ORDER_SUCCESS, types.GET_PRODUCTS_BY_ORDER_FAILED],
    payload: {
      api: 'gms',
      request: productRequests.getProductsByWorkorder(orderAccountUUID, workorderUUID)
    }
  })

export const addProductToOrder = (product: IProduct) => ({
  type: types.ADD_PRODUCT_TO_ORDER,
  payload: {
    product
  }
})

export const removeProductFromOrder = (productId: string) => ({
  type: types.REMOVE_PRODUCT_FROM_ORDER,
  payload: {
    productId
  }
})

export const rectifyOrderCart = (orderUUID: string) =>
  AsyncAction<responses.PUTRectifyOrderResponse>({
    type: [types.RECTIFY_ORDER_CART, types.RECTIFY_ORDER_CART_SUCCESS, types.RECTIFY_ORDER_CART_FAILED],
    payload: {
      api: 'gms',
      request: requests.rectifyOrder(orderUUID)
    }
  })

export const setOrderStatus = (orderUUID: string, orderStatus: WorkorderLineStatus) =>
  AsyncAction({
    type: [types.SET_ORDER_STATUS, types.SET_ORDER_STATUS_SUCCESS, types.SET_ORDER_STATUS_FAILED],
    payload: {
      api: 'gms',
      request: requests.setOrderStatus(orderUUID, orderStatus)
    }
  })

export const setDiscount = (workorderUUID: string, request: IDiscounts) =>
  AsyncAction<PUTDiscountResponse>({
    type: [types.SET_DISCOUNT, types.SET_DISCOUNT_SUCCESS, types.SET_DISCOUNT_FAILED],
    payload: {
      api: 'gms',
      request: workorderRequests.setDiscounts(workorderUUID, request)
    }
  })

export const getKeyloopWorkOrders = (params: IPaginatedRequestKeyloopWorkOrders) =>
  AsyncAction<responses.GETKeyloopWorkOrders>({
    type: [types.GET_KEYLOOP_WORKORDERS, types.GET_KEYLOOP_WORKORDERS_SUCCESS, types.GET_KEYLOOP_WORKORDERS_FAILED],
    payload: {
      api: 'gms',
      request: workorderRequests.getKeyloopWorkOrders(params)
    }
  })

export const getKeyloopWorkOrderRelatedJobs = (workorderUUID: string) =>
  AsyncAction<responses.GETKeyloopWorkOrderRelatedJobs>({
    type: [
      types.GET_KEYLOOP_WORKORDER_RELATED_JOBS,
      types.GET_KEYLOOP_WORKORDER_RELATED_JOBS_SUCCESS,
      types.GET_KEYLOOP_WORKORDER_RELATED_JOBS_FAILED
    ],
    payload: {
      api: 'gms',
      request: workorderRequests.getKeyloopWorkOrderRelatedJobs(workorderUUID)
    }
  })

export const getKeyloopWorkOrderColumns = (module: string) =>
  AsyncAction<responses.GETKeyloopWorkOrdersColumns>({
    type: [types.GET_KEYLOOP_WORKORDERS_COLUMNS, types.GET_KEYLOOP_WORKORDERS_COLUMNS_SUCCESS, types.GET_KEYLOOP_WORKORDERS_COLUMNS_FAILED],
    payload: {
      api: 'gms',
      request: settingsRequests.getSettings(module, 'list')
    }
  })

export const postKeyloopJobTransfer = (data: IPostKeyloopTransferBasket) =>
  AsyncAction<responses.POSTKeyloopJobTransfer>({
    type: [types.POST_KEYLOOP_JOB_TRANSFER, types.POST_KEYLOOP_JOB_TRANSFER_SUCCESS, types.POST_KEYLOOP_JOB_TRANSFER_FAILED],
    payload: {
      api: 'gms',
      request: workorderRequests.postKeyloopJobTransfer(data)
    }
  })

export const updateWorkOrderReference = (data: IUpdateWorkOrderReference) =>
  AsyncAction<workorderResponses.UpdateWorkOrderReference>({
    type: [types.PUT_WORKORDER_REFERENCE, types.PUT_WORKORDER_REFERENCE_SUCCESS, types.PUT_WORKORDER_REFERENCE_FAILED],
    payload: {
      api: 'gms',
      request: workorderRequests.updateWorkorderReference(data.workOrderUUID, data.orderReference)
    }
  })
